module.exports = __webpack_public_path__ + "img/step_03.a415cd45.png";